import { Injectable } from '@angular/core';
import { User } from '../models/user.model';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {
  user: User;
  environment: string = ''; // TODO

  constructor(private apiService: ApiService) {
    console.log('ProfileService()')
    this.user = new User();
  }

  submit() {
    this.user.username = this.user.emailAddress;
    return this.apiService.postUser(this.user, this.environment);
  }
}
